var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShoppingBagIcon = function SvgShoppingBagIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    clipPath: "url(#ShoppingBagIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.99 0h-.005a3.37 3.37 0 0 0-2.163.802 3.5 3.5 0 0 0-1.176 2.023.734.734 0 0 0 .566.862.72.72 0 0 0 .842-.58c.089-.46.33-.874.683-1.173a1.96 1.96 0 0 1 1.252-.465c.46.002.904.168 1.258.468s.596.719.682 1.182c.075.398.45.66.84.583a.734.734 0 0 0 .57-.86A3.52 3.52 0 0 0 11.163.806 3.37 3.37 0 0 0 8.991 0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14.053 4.408H3.948a1.7 1.7 0 0 0-1.134.39 1.77 1.77 0 0 0-.62 1.09L.76 16.11l-.007.065a1.77 1.77 0 0 0 .497 1.322 1.657 1.657 0 0 0 1.27.502h12.962c.23.01.46-.027.675-.11.223-.087.426-.22.595-.392.17-.173.301-.38.387-.607a1.8 1.8 0 0 0 .103-.78L15.806 5.888l-.004-.023c-.072-.42-.29-.8-.615-1.068a1.7 1.7 0 0 0-1.134-.39M3.714 5.94a.28.28 0 0 1 .192-.065l.03.001h10.158c.07-.003.138.02.192.064a.3.3 0 0 1 .1.17l1.428 10.166a.27.27 0 0 1-.075.178.25.25 0 0 1-.196.075l-.043-.001h-13l-.043.001a.25.25 0 0 1-.196-.076.26.26 0 0 1-.075-.178L3.613 6.111a.3.3 0 0 1 .101-.17",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ShoppingBagIcon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h18v18H0z"
  })))));
};
export default SvgShoppingBagIcon;